var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-projects-section"},[(this.$mq !== 's')?_c('div',{staticClass:"about-projects-section-decor"},[_c('div',{staticClass:"about-projects-section-decor-dot"})]):_vm._e(),_c('span',{staticClass:"about-projects-section-year",class:{
      'text-body1': _vm.$mq === 'xl' || _vm.$mq === 'l',
      'text-body3': _vm.$mq === 'm',
      'text-body6': _vm.$mq === 's'
    }},[_vm._t("year")],2),_c('p',{staticClass:"about-projects-section-txt",class:{
      'text-body3': _vm.$mq === 'xl' || _vm.$mq === 'l',
      'text-body5': _vm.$mq === 'm',
      'text-body6': _vm.$mq === 's'
    }},[_vm._t("text")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }